module.exports = __webpack_public_path__ + "static/media/藥膳排骨.275a2485.jpg";